import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { isEqual } from "lodash";
import moment from "moment";
import {
    exportOrdersExcel,
    fetchExportOrdersHistory, fetchNotExportedOrders,
    fetchOrderExportLayouts, saveExportOrdersHistory, saveNotExportedOrders
} from "../../../../api/menu/export/orders/actions";
import SearchSelect from "../../../common/SearchSelect";
import { fetchSuppliersList } from "../../../../api/menu/master-files/suppliers/actions";
import { fetchJobs } from "../../../../api/menu/master-files/job-maintenance/actions";
import ExportOrdersListHeader from "./list-header";
import NotExportedOrdersList from "./not-exported-order-list";
import OrderHistoryList from "./order-history-list";

class ExportOrderList extends React.Component {
    dateFormat = "YYYY-MM-DD";

    tabs = {
        notExportedOrders: "notExportedOrders",
        ordersHistory: "ordersHistory"
    };

    defaultFilters = {
        jobId: null,
        supplerId: null
    };

    constructor(props) {
        super(props);

        this.state = {
            currentTab: this.tabs.notExportedOrders,
            filters: {
                jobId: null,
                supplierId: null,
                fromDate: moment()
                    .startOf("month"),
                toDate: moment(),
            },
            selectedLayout: {},
            layoutOptions: [],
            suppliersOptions: [],
            jobOptions: [],
            selectedNotExportedOrders: []
        };

        this.props.fetchOrderExportLayouts();

        this.handleSelect = this.handleSelect.bind(this);
        this.handleSelectLayout = this.handleSelectLayout.bind(this);
        this.getRequestData = this.getRequestData.bind(this);
        this.handleLoadNotExportedOrders = this.handleLoadNotExportedOrders.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.handleCheckOrders = this.handleCheckOrders.bind(this);
        this.toggleOrder = this.toggleOrder.bind(this);
        this.handleExport = this.handleExport.bind(this);
        this.handleSelectDates = this.handleSelectDates.bind(this);
        this.selectTab = this.selectTab.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const newState = {};

        if (!isEqual(nextProps.orderLayouts, this.props.orderLayouts)) {
            newState.layoutOptions = nextProps.orderLayouts.map((value) => {
                const currentOption = {
                    label: value.name,
                    value: value.orderExportLayoutId,
                };

                if (value.orderExportLayoutId === 1) {
                    newState.selectedLayout = currentOption;
                }

                return currentOption;
            });
        }

        if (Object.keys(newState).length) {
            this.setState(newState);
        }
    }

    getRequestData = () => {
        const { currentTab } = this.state;

        const {
            jobId,
            supplierId,
            fromDate,
            toDate
        } = this.state.filters;

        const requestData = {};

        if (jobId) {
            requestData.jobId = jobId.value;
        }
        if (supplierId) {
            requestData.supplierId = supplierId.value;
        }

        if (currentTab === this.tabs.ordersHistory) {
            requestData.fromDate = moment(fromDate)
                .format(this.dateFormat);
            requestData.toDate = moment(toDate)
                .format(this.dateFormat);
        }

        return requestData;
    };

    handleLoadNotExportedOrders = ()  => {
        const { currentTab } = this.state;
        const requestData = this.getRequestData();

        if (currentTab === this.tabs.notExportedOrders) {
            this.setState({
                selectedNotExportedOrders: []
            }, () => this.props.fetchNotExportedOrders(requestData));
        }

        if (currentTab === this.tabs.ordersHistory) {
            this.props.fetchExportOrdersHistory(requestData);
        }
    };

    handleSelectDates = (name, option) => {
        const filters = Object.assign({}, this.state.filters);
        filters[name] = option;
        this.setState({
            filters
        });
    };

    handleReset = () => {
        const { currentTab } = this.state;
        this.setState({
            filters: this.defaultFilters,
            selectedNotExportedOrders: []
        }, () => {
            if (currentTab === this.tabs.ordersHistory) {
                this.props.saveExportOrdersHistory([]);
            }
            if (currentTab === this.tabs.notExportedOrders) {
                this.props.saveNotExportedOrders([]);
            }
        });
    };

    toggleOrder = (data, id) => {
        const index = data.indexOf(id);

        if (index >= 0) {
            data.splice(index, 1);
        } else {
            data.push(id);
        }

        return data;
    }

    selectTab = (key) => {
        if (key === this.tabs.notExportedOrders) {
            this.props.saveExportOrdersHistory([]);
        }

        if (key === this.tabs.ordersHistory) {
            this.props.saveNotExportedOrders([]);
        }
        this.handleSelectLayout("currentTab", key);
    }

    handleCheckOrders(orders) {
        if (Array.isArray(orders)) {
            this.setState({
                selectedNotExportedOrders: orders
            });
            return;
        }

        let data;

        const { currentTab } = this.state;

        const selectedNotExportedOrders = Object.assign([], this.state.selectedNotExportedOrders);

        if (currentTab === this.tabs.notExportedOrders) {
            data = this.toggleOrder(selectedNotExportedOrders, orders);
            this.setState({
                selectedNotExportedOrders: data
            });
        }
    }

    handleSelectLayout(key, value) {
        this.setState({
            [key]: value
        });
    }

    handleSelect = (inputsArr) => {
        const filters = Object.assign({}, this.state.filters);
        inputsArr.forEach(item => {
            filters[item.name] = item.value;
        });
        this.setState({
            filters
        });
    };

    handleExport = () => {
        const {
            filters,
            selectedLayout,
            selectedNotExportedOrders
        } = this.state;

        const requestBody = {
            orderLayoutId: selectedLayout.value,
            supplierId: filters.supplierId.value,
            data: selectedNotExportedOrders
        };

        this.props.exportOrdersExcel(requestBody, this.handleLoadNotExportedOrders);
    };

    render() {
        const {
            currentTab,
            selectedNotExportedOrders,
            filters
        } = this.state;
        const isHistoryView = currentTab === this.tabs.ordersHistory;
        const isDisabledLoad = !(filters.supplierId && filters.jobId);

        return (
            <div>
                <div className="row">
                    <div className="col-4">
                        <h3 className="mb-4">
                            Order Maintenance
                        </h3>
                    </div>
                    <div className="col-2">
                        <div className="form-group">
                            <label className="d-block mb-0 font-weight-bold form-label">
                                Layouts
                            </label>
                            <SearchSelect
                                className="custom-react-select"
                                isLoading={false}
                                isClearable={true}
                                isSearchable={true}
                                options={this.state.layoutOptions}
                                value={this.state.selectedLayout}
                                onChange={(option) => this.handleSelectLayout("selectedLayout", option)}
                            />
                        </div>
                    </div>
                </div>
                <ExportOrdersListHeader
                    filters={this.state.filters}
                    isHistoryView={isHistoryView}
                    isDisabledExport={selectedNotExportedOrders.length === 0}
                    isDisabledLoad={isDisabledLoad}
                    handleSelect={this.handleSelect}
                    handleLoad={this.handleLoadNotExportedOrders}
                    handleReset={this.handleReset}
                    handleExport={this.handleExport}
                    handleSelectDates={this.handleSelectDates}
                />
                <Tabs
                    id="order-tabs"
                    activeKey={this.state.currentTab}
                    onSelect={(key) => this.selectTab(key)}
                    className="w-100"
                    mountOnEnter={true}
                    unmountOnExit={true}
                >
                    <Tab
                        eventKey={this.tabs.notExportedOrders}
                        title="NotExported"
                    >
                        <NotExportedOrdersList
                            handleCheckOrders={this.handleCheckOrders}
                            selectedNotExportedOrders={this.state.selectedNotExportedOrders}
                        />
                    </Tab>
                    <Tab
                        eventKey={this.tabs.ordersHistory}
                        title="History"
                    >
                        <OrderHistoryList/>
                    </Tab>
                </Tabs>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    ordersHistory: state.export.ordersHistory,
    orderLayouts: state.export.orderLayouts,

    jobs: state.jobs.jobs,

    suppliers: state.suppliers.suppliers,
});

const mapStateToDispatch = dispatch => ({
    fetchOrderExportLayouts: bindActionCreators(fetchOrderExportLayouts, dispatch),
    fetchExportOrdersHistory: bindActionCreators(fetchExportOrdersHistory, dispatch),
    saveExportOrdersHistory: bindActionCreators(saveExportOrdersHistory, dispatch),
    fetchNotExportedOrders: bindActionCreators(fetchNotExportedOrders, dispatch),
    saveNotExportedOrders: bindActionCreators(saveNotExportedOrders, dispatch),
    exportOrdersExcel: bindActionCreators(exportOrdersExcel, dispatch),

    fetchSuppliersList: bindActionCreators(fetchSuppliersList, dispatch),
    fetchJobs: bindActionCreators(fetchJobs, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(ExportOrderList);
